// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1682418563426
      var cssReload = require("/srv/www/iclaimthisname.com/current/web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  